var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users-list users-list-driverhelpers"},[_c('list-users',{attrs:{"users":_vm.allDriverHelpers,"type":"driverhelpers"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }